import { useLayoutEffect, type RefObject } from 'react';

/**
 * Promotes an element into the browser's top layer (via the Popover API) so it
 * renders above open modal <dialog>s. Call again when content changes to move it
 * to the top of the stack. Falls back gracefully where the API is unavailable.
 */
export function useTopLayer(ref: RefObject<HTMLElement | null>, active: boolean, deps: unknown[] = []) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || typeof el.showPopover !== 'function') return;
    try {
      if (el.matches(':popover-open')) el.hidePopover();
      if (active) el.showPopover();
    } catch {
      /* Element not connected yet or API unsupported — normal stacking still applies. */
    }
  }, [active, ...deps]);
}
